<template>
    <div class="page-wrapper"
        v-if="isLoaded">
        <TopBarGray
            :title="lbl.edit_profile.page_title"
            @clickBack="clickBack()" />
        <div id="edit_profile_content" class="page-content">
            <GenderRadio
                :isTitle="true"
                id='gender_radio'
                :inputId="'title'"
                :inputLbl='lbl.edit_profile.title'
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
                v-model="profile.title" 
                @input="onUpdateForm()"/>
            <TextInput
                addClass="edit-profile-field"
                inputId="edit_profile_firstname_txt"
                :inputLbl="lbl.edit_profile.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :isTextOnly="true"
                :isRequired="true"
                :errorInfo="errorInfo[1]"
                v-model="profile.firstName" 
                @input="onUpdateForm()"/>
            <TextInput
                addClass="edit-profile-field"
                inputId="edit_profile_lastname_txt"
                :inputLbl="lbl.edit_profile.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :isTextOnly="true"
                :isRequired="true"
                :errorInfo="errorInfo[2]"
                v-model="profile.lastName" 
                @input="onUpdateForm()"/>
            <GenderRadio
                :isGender="true"
                id='gender_radio'
                :inputId="'gender'"
                :inputLbl='lbl.edit_profile.gender'
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
                v-model="profile.gender" 
                @input="onUpdateForm()"/>
            <DropdownDatePicker
                addClass="edit-profile-field"
                formId="formInfo"
                :inputLbl="lbl.edit_profile.birthdate"
                :isDisable="isDisableBirthDate"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowBirthDateErrorLbl"
                :errorInfo="errorInfo[4]"
                :isRequired="true"
                @onDateChange="onDateChange($event)"
                @onSelectDate="onSelectDate()"
                v-model="birthdate" />
            <TextInput
                addClass="edit-profile-field"
                inputId="edit_profile_contact_number"
                :inputLbl="lbl.edit_profile.contact_number"
                :isFirstSave="isFirstSave"
                :errorInfo="errorInfo[5]"
                :blockAutoComplete="true"
                :isRequired="true"
                v-model="displayContactNumber" />
            <Email
                addClass="edit-profile-field"
                inputId="edit_profile_email"
                :inputLbl="lbl.edit_profile.email"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="isShowErrorLbl"
                :errorInfo="errorInfo[6]"
                v-model="profile.email" 
                :isRequired="true"
                @input="onUpdateForm()"/>
            <TextAreaInput
                addClass="edit-profile-area"
                inputId="edit_profile_address"
                :inputLbl="lbl.edit_profile.address.address"
                :isFirstSave="isFirstSave"
                :errorInfo="errorInfo[7]"
                :isRequired="true"
                v-model="profileAddress.address" 
                @input="onUpdateForm()"/>
            <FormAddressDropDown
                addClass="edit-profile-adress"
                :address="profileAddress"
                formId="formRegister"
                inputId="registerAddress"
                :lblShipping="lbl.edit_profile.address"
                :zipcodeError="errorInfo[8]"
                :provinceError="errorInfo[9]"
                :districtError="errorInfo[10]"
                :subDistrictError="errorInfo[11]" 
                :isRequired="true"
                @input="onUpdateForm()"/>
            <Button
                btnId="update_profile"
                :isBtnDisable="!isFormValid"
                :btnMsg="isHasExtensionJsonProperty ? lbl.edit_profile.save_btn : lbl.register.btn_next"
                @clickButton="clickUpdateProfile()" />
        </div>

        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import FormHelper from '@/helper/FormHelper.js';
import Util from '@/helper/Utility.js';
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import Button from '@/components/Button/Button.vue';
import Email from '@/components/Input/Email.vue'
import DropdownDatePicker from '@/components/Input/DropdownDatePicker.vue';
import FormAddressDropDown from "@/components/Form/FormAddressDropDown.vue";
import TextAreaInput from '@/components/Input/TextAreaInput.vue';
import TextInput from "@/components/Input/Text.vue";
import TopBarGray from '@/components/Layout/TopBarPage/TopBarGray.vue';
import GenderRadio from '@/components/Input/GenderRadio.vue'
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";

export default {
    name: 'EditProfile',
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        Button,
        DropdownDatePicker,
        Email,
        FormAddressDropDown,
        TextAreaInput,
        TextInput,
        TopBarGray,
        GenderRadio
    },
    data: function () {
        return {
            title: '',
            displayContactNumber: '',
            birthdate: null,
            errorInfo: [],
            profileAddress: new AddressModel(),
            isDisableBirthDate: true,
            isFirstSave: true,
            isSelectDate: false,
            isShowErrorLbl: true,
            isShowBirthDateErrorLbl: false,
            isShowEmailErrorLbl: false,
            isLoaded: false,
            isLoading: false,
            isFormValid: false,
            
        };
    },
    created: function () {
        this.errorInfo = FormHelper.genErrorInfo(12);
    },
    computed: {
        isHasExtensionJsonProperty: function () {
            return this.profile && !Util.isEmptyStr(this.profile.extensionJsonProperty);
        },
    },
    methods: {
        //event
        clickBack: function () {
            this.$router.back();
        },
        clickUpdateProfile: function () {
            var isBD = this.validateBD();
            var isEmail = this.validateEmail();
            if (this.isFormValid && isBD && isEmail) {
                if (this.isLoading) return;
                if (!this.isHasExtensionJsonProperty) {
                    const cache = new CacheHelper('session');
                    cache.setCache('profile', this.profile);
                    cache.setCache('profileAddress', this.profileAddress);
                    this.$router.push('/surveyeditprofile');
                } else {
                    this.callApiUpdateProfile();
                }
            }

        },

        callApiUpdateProfile: function () {
            this.loadingModal.show();
            console.log("apiUpdateProfile",  this.profile, this.profileAddress);
            Account.apiUpdateProfile(this.profile, this.profileAddress)
                .then(() => {
                    this.loadingModal.hide();
                    this.isLoading = false;

                    this.successModal
                        .clearText()
                        .setMsg(this.lbl.edit_profile.update_success)
                        .setBtnOk(this.lbl.edit_profile.btn_confirm)
                        .setTag('edit-profile')
                        .show();

                    this.successModal
                        .onClickOk((data) => {
                            if(data.tag == 'edit-profile'){
                                var cache = new CacheHelper('session');
                                cache.setCache('isFromEditProfile', true);
                                cache.setCache('isReload', true);
                                this.$router.push('/profile');
                            }
                        });
                }).catch(err => {
                    this.loadingModal.hide();
                    this.isLoading = false;

                    this.errorApi(err);
                });
            this.isFirstSave = false;
        },
        onDateChange: function (data) {
            this.profile.birthDate = data.timestamp;
            this.onUpdateForm();
        },
        onSelectDate: function () {
            this.isSelectDate = true;
        },
        //mixin
        accountInitiated: function () {
            this.initialEditProfile();
            this.onUpdateForm();
        },
        //initial
        initialEditProfile: function () {
            
            this.isLoaded = true;
            
            if(this.profile.birthDate != ''){
                this.birthdate = DatetimeHelper.convertTimestampToDate(this.profile.birthDate);
                this.isDisableBirthDate = true;
            }else{
                this.isDisableBirthDate = false;
            }

            this.displayContactNumber = Util.contactNumberFormat(this.profile.contactNumber, '-').slice(0, -4) + "xxxx";
            this.profileAddress = this.getProfileAddress();
            console.log('profile', this.profile);
            
            switch (this.profile.title){
                case 'mr':
                    this.title = "นาย";
                    break;
                case 'mrs':
                    this.title = "นาง";
                    break;
                case 'miss':
                    this.title = "นางสาว";
                    break;
                default:
                    this.title = this.profile.title;
                    break;
            }
        },
        //method
        //validate
        validateBD: function () {
            if (this.isSelectDate) { 
                if(this.errorInfo[4].isValid){
                    this.isShowBirthDateErrorLbl = false;
                    return true;
                }else{
                    this.isShowBirthDateErrorLbl = true;
                    return false;
                }
            }else{
                return true;
            }
        },
        validateEmail: function(){
            if (this.profile.email) { 
                if(this.errorInfo[6].isValid){
                    this.isShowEmailErrorLbl = false;
                    return true;
                }else{
                    this.isShowEmailErrorLbl = true;
                    return false;
                }
            }else{
                return true;
            }  
        },
        onUpdateForm: function(){
            let valid = FormHelper.validate(this.errorInfo);
            this.isFormValid = valid;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "../style/EditProfile.scss";
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/input/Text.scss";
.wrap-input {

    .input-box {
        position: unset;
    }

    &.edit-profile-field {
        margin-top: 20px;

        .ddl-input {
            .btn-ddl-input {
                margin-top: 0;
            }
        }
    }

    &.edit-profile-area {
        margin-top: 20px;
        .input-box .input-field {
            border-radius: 15px;
        }
    }

    &.edit-profile-adress {
        margin-top: 20px;

        .ddl-input {
            .btn-ddl-input {
                margin-top: 0;
            }
        }
    }
}
</style>
